import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Price = ApplicationRecord.extend({
  static: {
    jsonapiType: 'prices',
  },
  attrs: {
    begin: attr(),
    price: attr(),
    priceWithout: attr(),
    schoolId: attr({ persist: false }),
    enddate: attr(),
    createdAt: attr({ persist: false }),
    updatedAt: attr({ persist: false }),
    school: belongsTo(),
    option: belongsTo(),
    package: belongsTo(),
  }
});

export default Price;
